// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import ProductListPage from '@/pages/ProductListPage.vue';
import ProductDetailPage from '@/pages/ProductDetailPage.vue';
import PaymentPage from '@/pages/PaymentPage.vue';
import OrderCompletePage from '@/pages/OrderCompletePage.vue';
import MyOrderPage from '@/pages/MyOrderPage.vue';
import InquiryPage from '@/pages/InquiryPage.vue';
import InquiryListPage from '@/pages/InquiryListPage.vue';
import InquiryDetailPage from '@/pages/InquiryDetailPage.vue';
import PayResultPage from '@/pages/PayResultPage.vue';
import OrderInquiryPage from '@/pages/OrderInquiry.vue';
import OrderListPage from '@/pages/OrderList.vue';
import TimeDealPage from '@/pages/TimeDealPage.vue';

const routes = [
  { path: '/', name: 'Home', component: ProductListPage },
  { path: '/productDetail/:code', name: 'ProductDetail', component: ProductDetailPage },
  { path: '/myOrder', name: 'MyOrder', component: MyOrderPage },
  { path: '/orderComplete', name: 'OrderComplete', component: OrderCompletePage },
  { path: '/payment', name: 'Payment', component: PaymentPage },
  { path: '/payResult', name: 'PayResult', component: PayResultPage },
  { path: '/inquiry', name: 'Inquiry', component: InquiryPage },
  { path: '/inquiryList', name: 'InquiryList', component: InquiryListPage },
  { path: '/inquiryDetail', name: 'InquiryDetail', component: InquiryDetailPage },
  { path: '/orderInquiry', name: 'OrderInquiry', component: OrderInquiryPage },
  { path: '/orderList', name: 'OrderList', component: OrderListPage },
  { path: '/timeDeal', name: 'TimeDeal', component: TimeDealPage },
];
export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  },
});
